import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { InputChipData } from "@/shared/components/InputChipString/models/InputChipData";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import { ConfigInputs, SourceInfoDetails } from "../../models/ActionPlan.model";
import CardInputs from "../CardInputs/CardInputs.vue";
import InputChipString from "./../../../../shared/components/InputChipString/InputChipString.vue";
import { STYLE_CLASSES } from "./../../../../shared/constants/StyleConstants";

@Component({
  name: "CardOutputs",
  components: {
    InputChipString,
    CardInputs,
    DynamicSelect
  }
})
export default class CardOutputs extends Vue {
  @Prop({ default: () => false }) isHeader!: boolean;
  @Prop({ default: () => "" }) nameActionPlan!: string;
  @Prop() configInputs!: ConfigInputs;
  @Prop() configSelect!: string;
  @Prop() sourceInfoDetails!: SourceInfoDetails;
  @Prop({ default: () => ({}) }) pdfSection!: PdfTemplateSection;

  rules = {
    section: [FORM_VALIDATORS.REQUIRED_FIELD, FORM_VALIDATORS.REQUIRED_ARRAY]
  };

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;

  rowSelect = 0;
  colSelect = 0;
  isCollapseInput = true;

  sectionConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.sourceInfoDetails.sections.map(item => {
      return { id: item.key!, name: item.name };
    }),
    messageLabel: this.TITLES.SECCION_SERVICE,
    required: true
  };
  sectionModel = [{ id: "", name: "" }];

  get isCollapse(): boolean {
    return this.configSelect != this.configInputs.title;
  }

  get styleTitle() {
    let style = "";
    if (!this.isCollapse && this.pdfSection) {
      style += "color:" + this.pdfSection.mainColor;
    }
    return style;
  }

  @Watch("sourceInfoDetails", { deep: true })
  setSectionList() {
    this.sectionConfigList.listAll = this.sourceInfoDetails.sections.map(
      item => {
        return { id: item.key!, name: item.name };
      }
    );
    this.sectionModel = [
      {
        id: this.configInputs.sectionService?.key ?? "",
        name: this.configInputs.sectionService?.name ?? ""
      }
    ];
  }

  @Watch("sectionModel")
  setService() {
    this.configInputs.sectionService = this.sourceInfoDetails.sections.find(
      item => item.key == this.sectionModel[0].id
    );
  }

  changeCollapse() {
    this.$emit(
      "changeSelectOutput",
      this.isCollapse ? this.configInputs.title : ""
    );
  }

  openInputs(indexRow: number, indexCol: number, event: boolean) {
    this.rowSelect = indexRow;
    this.colSelect = indexCol;
    this.isCollapseInput = event;
  }

  selectInputs(indexRow: number, indexCol: number) {
    this.isCollapseInput = true;
    this.rowSelect = indexRow;
    this.colSelect = indexCol;
  }

  pushField(event: InputChipData) {
    this.isCollapseInput = true;
    this.configInputs.groupInputs[this.rowSelect].inputs[
      this.colSelect
    ].formula.push(event);
  }
}
